import React, { Component } from 'react'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { isJsonString } from '../../../../../utils';
import { FontAwesomeIcon } from '../../../../CommonComponents/AssetsHelper';
export default class ReconnectError extends Component {
    render() {
        const { msg } = this.props;
        const errorMsg = "Feed disconnected as the social media account's user name got changed since your last connection with Taggbox. Kindly click on the button below to reconnect.";

        return (
            <div className="d-flex align-items-center">
                <div className="d-flex align-items-center reconnect200791">
                   <OverlayTrigger overlay={<Tooltip>{(msg && msg.length > 0) ?  isJsonString(msg) ? JSON.parse(msg).error ? JSON.parse(msg).error.message  : errorMsg :  msg : errorMsg}</Tooltip>}>  
                   
                    <div className="mx-2">
                        <FontAwesomeIcon type={'solid'} icon={'circle-info'} iconClass={'text-gray-500'} />
                    </div>
                  </OverlayTrigger>  

                    <OverlayTrigger overlay={<Tooltip>Click to resolve issue</Tooltip>}>

                        <a href="#" className="resetAction retry btn btn-danger btn-sm" title="">
                            <span className="reconnect_feed">
                                <FontAwesomeIcon type={'solid'} icon={'circle-info'} iconClass={'me-1'} />
                                Reconnect
                            </span>
                        </a>
                    </OverlayTrigger>

                </div>
            </div>
        )
    }
}
